import { Role } from './role.model';

export class Department {
	public name: string;
	public roles: Role[];
}
